import { MouseEvent } from "react";
import Icon from "../../common/Icon";

interface ThumbButtonProps {
    state: boolean;
    onIconClick: (e: MouseEvent<HTMLElement>) => void;
}

const ThumbButton = (props: ThumbButtonProps) => {
    return (
        <label onClick={props.onIconClick}>
            {props.state ? <Icon name="thumbUp" color="default" cursor="pointer" /> : <Icon name="thumbUp" color="lightGrey" cursor="pointer" />}
        </label>
    );
};
export default ThumbButton;
